module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "idRadioPanel",
    attrs: {
      "id": "idRadioPanel"
    }
  }, [_c('div', {
    ref: "idRadBdr",
    attrs: {
      "id": "idRadBdr"
    },
    on: {
      "click": _vm.onRadClick
    }
  }, [_c('div', {
    ref: "idRadCirc",
    attrs: {
      "id": "idRadCirc"
    }
  })]), _vm._v(" "), _c('div', {
    ref: "idRadCapt",
    attrs: {
      "id": "idRadCapt"
    }
  }, [_vm._v(_vm._s(_vm.capt))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-776bfb1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/cf/cradio.vue
// module id = 785
// module chunks = 1